// extracted by mini-css-extract-plugin
module.exports =  {"chats_container":"_103a151b99--chats_container--uRlLn","list":"_103a151b99--list--UEA4e","chat":"_103a151b99--chat--rQO7o"};